/** Espelha `AnnouncementType` do backend: o obrigatório pede ciência, o dispensável se fecha. */
export enum AnnouncementType {
  MANDATORY = 'MANDATORY',
  DISMISSIBLE = 'DISMISSIBLE',
}

/** Para o formulário, onde ainda não há comunicado em mão. */
export const ANNOUNCEMENT_TYPE_DESCRIPTION: Record<AnnouncementType, string> = {
  [AnnouncementType.MANDATORY]: 'Obrigatório',
  [AnnouncementType.DISMISSIBLE]: 'Dispensável',
};
